import { ThemeIcon as MantineThemeIcon, ThemeIconProps } from '@mantine/core';

export type IThemeIconProps = ThemeIconProps;

/** @registry Design-layer pass-through over Mantine ThemeIcon; import this instead of @mantine/core ThemeIcon outside src/design. */
export const ThemeIcon = MantineThemeIcon;
